import {LoginForm} from '@/core/components/auth/login-form'
import {Link} from '@/core/components/link'
import {doc} from './doc'
import styles from './style.module.styl'

export const LoginPage = doc(
  ({onSuccess, fetchUserInfo}) => {
    return (
      <div className={styles.login} >
        <h1>Login</h1>
        <LoginForm onSuccess={onSuccess} fetchUserInfo={fetchUserInfo} />
        <p><Link name='login'>Forgot password?</Link></p>
        <p>Don't have an account? <Link name='login'>Sign up.</Link></p>
      </div>
    )
  }
)
